import React, { PureComponent } from 'react'
import Link from 'next/link'
import Router from 'next/router'
import cloneDeep from 'lodash/cloneDeep'

import IconCaretDown from 'Images/SVG/CaretDown.svg'
import { DirectoryLinkAs, DirectoryLinkHref, WithFacetSlug } from 'utils/DirectoryParser'
import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import {
  Dropdown,
  FacetDropdownButton,
  DropdownContent,
  DropDownContentContainer,
  AnchorsContainer,
  DropdownFilterInput,
  FacetDropdownAnchor,
  DropdownCenteredContent,
  FacetAnchorContainer,
  FacetDropdownContainer,
  FacetAnchorTitle,
} from './Styled'

class FacetDropdown extends PureComponent {
  state = {
    showFacetDropdown: false,
    filterableFacets: this.props.facet.slugs,
  }

  dropdownRef = React.createRef()
  inputRef = React.createRef()

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
    Router.events.on('routeChangeStart', () => {
      this.setState({ showFacetDropdown: false })
    })
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside = (event) => {
    const {
      facet: { slugs },
    } = this.props
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      // Hide dropdown and reset list
      this.setState({ showFacetDropdown: false, filterableFacets: slugs })
    } else if (
      this.inputRef &&
      this.inputRef.current &&
      this.inputRef.current.contains(event.target)
    ) {
      this.setState({ showFacetDropdown: true })
    } else {
      this.setState((prevState) => ({
        showFacetDropdown: !prevState.showFacetDropdown,
        filterableFacets: slugs,
      }))
    }
  }

  filterList = (event) => {
    const value = event && event.target && event.target.value && event.target.value
    const {
      facet: { slugs },
    } = this.props
    let updatedList = slugs

    updatedList = updatedList.filter((facet) => {
      if (
        facet &&
        facet.label &&
        event.target &&
        event.target.value &&
        facet.label.toLowerCase().search(value.toLowerCase()) !== -1
      ) {
        return facet
      }
    })
    const emptySearchInput = value.trim() === ''
    if (updatedList.length === 0 && !emptySearchInput) {
      updatedList = []
    }
    if (emptySearchInput) {
      updatedList = slugs
    }
    this.setState({ filterableFacets: updatedList })
  }

  render() {
    const { selectedFacets, directoryLinkInformation, facet } = this.props
    const { showFacetDropdown, filterableFacets } = this.state

    const selectedFacet =
      selectedFacets &&
      facet &&
      facet.slugs &&
      facet.slugs.find((facet) => facet.slug.toLowerCase() === selectedFacets[0])

    // TODO: Cleanup PLEASE
    // This is a weird bit of logic that removes all the facets in the link information for this dropdown
    // This is to make it single selectable so that when we click another anchor in this dropdown we only have one facet in the url from the facet dropdown
    let directoryLinkInformationWithoutOtherDropdownItems = cloneDeep(directoryLinkInformation)
    if (selectedFacet && selectedFacet.slug) {
      directoryLinkInformationWithoutOtherDropdownItems = {
        ...directoryLinkInformationWithoutOtherDropdownItems,
        facetSlugs: directoryLinkInformationWithoutOtherDropdownItems.facetSlugs.filter(
          (linkFacet) => !(selectedFacet.slug.toLowerCase() === linkFacet)
        ),
      }
    }

    const Anchors =
      filterableFacets && filterableFacets.length > 0 ? (
        filterableFacets.map((facet, i) => {
          const newDirectoryLinkInformation = WithFacetSlug(
            directoryLinkInformationWithoutOtherDropdownItems,
            facet.slug
          )

          const as = DirectoryLinkAs(newDirectoryLinkInformation)
          const href = DirectoryLinkHref(newDirectoryLinkInformation)
          return (
            <Link scroll={false} href={href} as={as} key={i}>
              <FacetAnchorContainer key={i}>
                <FacetDropdownAnchor>{facet.label}</FacetDropdownAnchor>
              </FacetAnchorContainer>
            </Link>
          )
        })
      ) : (
        <FacetDropdownAnchor p='1px 0px 1px 16px' height='fit-content'>
          No results found
        </FacetDropdownAnchor>
      )

    return (
      <>
        <FacetAnchorTitle>{facet.name}</FacetAnchorTitle>
        <FacetDropdownContainer
          backgroundColor={showFacetDropdown ? '#ebebeb' : 'white'}
          borderColor={showFacetDropdown ? '#66afe9' : '#ccc'}
          showDropdown={showFacetDropdown}
          minWidth='220px'
          ref={this.dropdownRef}
        >
          <DropdownCenteredContent>
            <div>
              <Dropdown minWidth='180px'>
                <FacetDropdownButton>
                  {(selectedFacet && selectedFacet.label) || facet.name}
                </FacetDropdownButton>
                <DropdownContent
                  showDropdown={showFacetDropdown}
                  borderColor={showFacetDropdown ? '#66afe9' : '#ccc'}
                  ref={this.inputRef}
                >
                  <DropDownContentContainer width='220px'>
                    <DropdownFilterInput type='text' onChange={this.filterList} />
                    <AnchorsContainer>{Anchors}</AnchorsContainer>
                  </DropDownContentContainer>
                </DropdownContent>
              </Dropdown>
            </div>
          </DropdownCenteredContent>
          <GenericLazyLoadImage
            src={IconCaretDown}
            alt='Down Button'
            width='16px'
            height='18px'
            mt='8px'
            mr='8px'
          />
        </FacetDropdownContainer>
      </>
    )
  }
}

export default FacetDropdown
